module.exports = __webpack_public_path__ + "img/ph.dfa513c1.svg";